import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

import { fetchProductById, editProduct } from '../../services/product.service';
import AppModal from '../appModal.component';
import MessageContainer from '../message.component';
import WithLogin from '../withLogin.component';

const EditProduct = props => {
    const id = props.selectedRow.id;
    const [show, setModalShow] = useState(props.open);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState({});

    const handleModalClose = () => {
        setModalShow(false);
        props.setEditForm(false);
        props.reloadDataTable(1);
    };

    const getProduct = async () => {
        try {
            const resp = await fetchProductById(id);
            Object.keys(resp).forEach(key => {
                setValue(key, resp[key]);
            });

        } catch (error) {
            if (
                error.response.status === 400 ||
                error.response.status === 404
            ) {
                setMessage({
                    type: 'Error',
                    message: `${error.response.data.detail}`,
                });
            }
        }
    };

    useEffect(() => {
        getProduct()
        setModalShow(props.open);
        setMessage({});
    }, [props]); // eslint-disable-line react-hooks/exhaustive-deps

    const {
        reset,
        register,
        handleSubmit,
        setError,
        setValue,
        formState: { errors },
    } = useForm({
        defaultValues: {
            name: '',
            sku: ''
        },
    });

    const handleUpdateProduct = async data => {
        setLoading(true);
        try {
            setMessage({});
            await editProduct(id, data);
            setMessage({
                type: 'Success',
                message: 'Product has been updated successfully',
            });
            reset();
        } catch (error) {
            if (error.response.status === 400) {
                setMessage({
                    type: 'Error',
                    message: `${error.response.data.detail}`,
                });
                error.response.data.errors?.forEach(validationError => {
                    Object.keys(validationError).forEach(key => {
                        setError(key, { message: validationError[key] });
                    });
                });
            }
        }

        setLoading(false);
    };

    return (
        <AppModal
            size="lg"
            show={show}
            onHide={handleModalClose}
            backdrop="static"
            modalTitle="Edit Product">
            <div className="formView">
                <form
                    className="row g-2"
                    onSubmit={handleSubmit(handleUpdateProduct)}>
                    {message && message.type && (
                        <MessageContainer message={message} />
                    )}
                    <div className="col-md-6">
                        <label htmlFor="ProductName">Product Name</label>
                        <input
                            type="text"
                            className={
                                errors?.name
                                    ? 'form-control is-invalid'
                                    : 'form-control'
                            }
                            id="ProductName"
                            placeholder="Enter product name"
                            {...register('name', {
                                required: true,
                                maxLength: {
                                    value: 200,
                                    message:
                                        'product name can be max. 200 char length',
                                },
                            })}
                        />
                        {errors && (
                            <div className="invalid-feedback">
                                {errors.name?.message.replace('', '')}
                            </div>
                        )}
                    </div>
                    <div className="col-md-6">
                        <label htmlFor="Sku">Product Sku</label>
                        <input
                            type="text"
                            className={
                                errors?.sku
                                    ? 'form-control is-invalid'
                                    : 'form-control'
                            }
                            id="Sku"
                            disabled
                            placeholder="Enter sku"
                            {...register('sku', {
                                required: true,
                                maxLength: {
                                    value: 200,
                                    message:
                                        'Product Sku name can be max. 200 char length',
                                },
                            })}
                        />
                        {errors && (
                            <div className="invalid-feedback">
                                {errors.sku?.message.replace('', '')}
                            </div>
                        )}
                    </div>
                    <div className="col-md-12">
                        <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={loading}>
                            {loading && (
                                <span className="spinner-border spinner-border-sm"></span>
                            )}
                            Submit
                        </button>
                    </div>
                </form>
            </div>
        </AppModal>
    );
};

export default WithLogin(EditProduct);
